import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router";
import axios from 'axios';
import { usePostHog } from '@posthog/react';

import { AppContext } from '../../context.js';

import { Button } from '../components/component.js';

import Background from '../../files/background.png';
import LogoDark from '../../files/logo-dark.png';

function Login() {
  const context = useContext(AppContext);
  const posthog = usePostHog();

  const navigate = useNavigate();

  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');

  const [error, setError] = useState(null);

  function onClickLogin() {
    let u = context.addSpiner();
    axios.post('/api/public/login', {
      login: login,
      password: password
    }).then((r) => {
      posthog?.identify(r.data.id, {
        role: r.data.role,
      });
      posthog?.capture('user_logged_in', {
        role: r.data.role,
      });
      context.setState(
        r.data.token,
        r.data.role,
        r.data.id,
        r.data.name,
        r.data.language,
        r.data.dateFormat,
        r.data.timeFormat,
        r.data.expireAt,
        r.data.org,
        r.data.staffRole
      );
    }).catch((e) => {
      if (e.response && e.response.data && e.response.data.error) {
        setError(e.response.data.error);
      } else {
        setError("An unexpected error occurred. Please try again.");
      }
      posthog?.capture('login_failed', {
        status: e?.response?.status ?? 0,
      });
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }

  return (
    <div className="d-flex justify-content-between align-items-center h-100 w-100" style={{backgroundColor: '#11254F'}}>
              
      <div className="d-flex justify-content-center align-items-center w-100">
        <div style={{width: 400, paddingBottom: '15%'}}>
          <img src={LogoDark} className="w-50 mb-4" />

          <div className="typo-strong-300" style={{color: "white"}}>Welcome back</div>

          <div className="typo-medium-150 mb-4" style={{color: "white"}}>Enter your username and password to continue</div>

          <div className="typo-normal-125 mb-1" style={{color: "white"}}>Username</div>
          <input type="text" placeholder="Login" value={login} onChange={(e) => setLogin(e.target.value)} className="input w-100 mb-2" />
      
          <div className="typo-normal-125 mb-1" style={{color: "white"}}>Password</div>
          <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="input w-100 mb-4" />
        
          <Button color="blue" text="Log In" onClick={onClickLogin} className="w-100" />

          <div className="mt-3 w-100 text-center">
            <button 
              onClick={() => navigate("/forget")} 
              className="typo-normal-125"
              style={{
                background: "none", 
                border: "none", 
                color: "#87CEEB", 
                textDecoration: "underline",
                cursor: "pointer"
              }}
            >
              Forgot your password?
            </button>
          </div>

          <div className="mt-2 w-100 text-center" style={{height: 24}}>
            <div className="typo-strong-150 mt-2" style={{color: "white"}}>{error ? error : ""}</div>
          </div>

          {/* <br/>
          <br/>

          <div className="d-flex justify-content-center align-items-center mt-4">
            <img src={HipaaCR} className="" style={{height: 70}} />
            <img src={HipaaCG} className="ms-4" style={{height: 70}} />
          </div> */}

          {/* <br/>
          <br/>
          <br/>
          <br/> */}

          {/* <div>
            <div className="typo-strong-300 mb-1" style={{color: "white"}}>Refer & Earn with Carecierge!</div>
            <div className="typo-medium-150 mb-4" style={{color: "white"}}>Empower your network and enjoy the rewards! Invite colleagues and peers to join Carecierge, the leading solution for task management platform for Care Teams</div>

            <Button color="blue" text="Learn more about referral program" onClick={() => navigate("/referral")} className="w-100" />

          </div> */}
          

        </div>
      </div>
      <img src={Background} className={(context.scale === "lg" || context.scale === "xs" || context.scale === "xxl") ? "h-100" : context.scale === "md" ? "h-75" : "d-none"} />
    </div>
  );
}

export default Login;
